<template>
  <div>
    <Breadcrumb :options="breadcrumb" />

    <SearchField :form="formInline" :formCtrl="formCtrl" @onSearch="onSearch" @onReset="onReset"
      @onChange="onSearchItemChange"></SearchField>

    <Table ref="table" :tableData="tableData" :cols="cols" :page="page" :limit="limit" :total="total" :btns="btns"
      :allBtnWidth="allBtnWidth" @onSelectionChange="onSelectionChange" @onCurrentChange="onCurrentChange"
      @onSizeChange="onSizeChange">
      <template slot="dpost" slot-scope="params">
        <p>{{ params.params.dpost.split(',')[0] }}</p>
        <p>{{ params.params.dpost.split(',')[1] }}</p>
      </template>
      <template slot="main" slot-scope="params">
        <!-- 司机 -->
        <p :class="params.params[`dname${params.col.label}`] === '无' ? '' : 'nameBtn'"
          @click="showDetail(1, params.col.label, params.params)">
          {{ params.params[`dname${params.col.label}`] }}<span
            v-if="params.params[`driverwork${params.col.label}`].length || (params.params[`dtype${params.col.label}`] == 2)"
            style="color: #fd5b5b;">(缺勤)</span>
        </p>

        <!-- 打短司机 -->
        <p class="nameBtn" v-if="params.params[`driverwork${params.col.label}`].length"
          style="color: #E6A23C;cursor: auto;font-size: 12px;">
          <span v-for="(d, i) in params.params[`driverwork${params.col.label}`]" :key="'span' + i"
            style="cursor: pointer;" @click="showDetail(3, params.col.label, params.params, i)">
            {{ d.driver }}({{ Number(d.money) }})
          </span>
        </p>

        <!-- 押运 -->
        <p :class="params.params[`ename${params.col.label}`] === '无' ? '' : 'nameBtn'"
          @click="showDetail(2, params.col.label, params.params)">
          {{ params.params[`ename${params.col.label}`] }}<span
            v-if="params.params[`escortwork${params.col.label}`].length || (params.params[`etype${params.col.label}`] == 2)"
            style="color: #fd5b5b;">(缺勤)</span>
        </p>

        <!-- 打短押运 -->
        <p class="nameBtn" v-if="params.params[`escortwork${params.col.label}`].length"
          style="color: #E6A23C;cursor: auto;font-size: 12px;">
          <span v-for="(d, i) in params.params[`escortwork${params.col.label}`]" :key="'span' + i"
            style="cursor: pointer;" @click="showDetail(4, params.col.label, params.params, i)">
            {{ d.driver }}({{ Number(d.money) }})
          </span>
        </p>

        <!-- 添加 -->
        <i class="iconBtn el-icon-circle-plus" @click="showAddDetail(params.col.label, params.params)"></i>
      </template>
    </Table>

    <Dialog class="dialog" ref="dialog" :title="title" @closed="onDialogClose">
      <template #default>
        <el-form ref="mofalForm" :model="mform" :label-width="labelWidth" :rules="mrules">
          <!-- 日期 -->
          <FormItem :viewMode="mformCtrl[0].viewMode" :config="mformCtrl[0]" :options="mformCtrl[0].options"
            :inputValue="mform[mformCtrl[0].keyName]" @onChange="onModalChange" />

          <!-- 岗位 -->
          <el-form-item label="岗位" prop="type" class="item">
            <el-select v-model="mform.type" placeholder="请选择岗位" @change="changeType" filterable
              :disabled="mformCtrl[1].disabled">
              <el-option v-for="(n, i) in mformCtrl[1].options" :key="n.label + i" :label="n.label" :value="n.value">
              </el-option>
            </el-select>
          </el-form-item>

          <!-- 司机/押运列表 -->
          <FormItem v-show="[1, 2].includes(mform.type)" :config="mformCtrl[2]" :options="mformCtrl[2].options"
            :inputValue="mform[mformCtrl[2].keyName]" @onChange="onModalChange" />

          <!-- 打短司机/押运 -->
          <FormItem v-show="[3, 4].includes(mform.type)" :config="mformCtrl[3]" :options="mformCtrl[3].options"
            :inputValue="mform[mformCtrl[3].keyName]" @onChange="onModalChange" />

          <!-- 打短司机/押运其他信息 -->
          <div v-if="showmformCtrl1">
            <FormItem v-for="(c, i) in mformCtrl1" :key="'form1Item' + i" :viewMode="c.viewMode" :config="c"
              :options="c.options" :inputValue="mform[c.keyName]" @onChange="onModalChange" />
          </div>
        </el-form>

        <div class="btns">
          <el-button type="primary" @click="modalSubmitConfirm">确 定</el-button>
          <el-button v-if="title === '添加详情'" @click="hideDialog">取 消</el-button>
          <el-button v-if="title === '编辑详情'" type="danger" @click="delItem">删 除</el-button>
        </div>
      </template>
    </Dialog>
  </div>
</template>

<script>
import tableMixin from "../../mixin/table";

export default {
  mixins: [tableMixin],
  data() {
    return {
      baseUrl: 'carwork',
      breadcrumb: [
        { name: "考勤管理" },
        { name: "车辆考勤" },
      ],
      formInline: {
        month: undefined,
      },
      formCtrl: [
        {
          label: "月份",
          keyName: "month",
          placeholder: "请选择月份",
          type: "month",
        },
        {
          ...this.ctrls.fleet,
          options: [],
          className: "carcap",
        },
        {
          label: "车牌号",
          keyName: "license",
          placeholder: "请填写车牌号",
          type: "text",
        },
      ],
      cols: [
        { keyName: "license", label: "车牌号", fixed: true, width: 100 },
        { keyName: "dpost", label: "岗位", fixed: true, slot: 'dpost' },
      ],
      baseParams: ['month'],
      title: '添加详情',
      mform: {
        // name: undefined,
        getid: '',
      },
      mrules: {
        // getid: [
        //   { required: true, message: "请选择姓名", trigger: "blur" },
        // ],
      },
      mformCtrl: [
        {
          label: "日期",
          keyName: "monthday",
          err: "请选择日期",
          type: "date",
        },
        {
          label: "类型",
          keyName: "type",
          err: "请选择类型",
          type: "select",
          options: [
            { label: '司机', value: 1 },
            { label: '押运员', value: 2 },
            { label: '打短司机', value: 3 },
            { label: '打短押运员', value: 4 },
          ],
        },
        {
          label: "姓名",
          keyName: "getid",
          type: "select",
          err: "请选择姓名",
          options: [],
        },
        {
          label: "姓名",
          keyName: "get_name",
          type: "textSelect",
          err: "请填写姓名",
          options: [],
        },
      ],
      mformCtrl1: [
        {
          label: "工资",
          keyName: "money",
          err: "请填写金额",
          type: "number",
        },
        {
          label: "出处",
          keyName: "paymoney",
          err: "请选择出处",
          type: "select",
          options: [
            { label: '公司代付', value: 2 },
            { label: '司机支付', value: 1 },
          ],
        },
        {
          label: "备注",
          keyName: "remark",
          err: "请填写备注",
          type: "textarea",
        },
      ],
      labelWidth: '110px',
      showmformCtrl1: false,
      modalSubmitUrl: 'addkapqin',
    };
  },
  methods: {
    tableDataHandler({ count, data }) {
      this.total = count
      if (data && data.length) {
        this.tableData = [...data]
      }
      this.getDayCount()
    },
    getDayCount() {
      this.cols.length = 2
      let date = new Date()
      const curMonth = date.getMonth() + 1
      // console.log('当前月份',curMonth)
      let day = date.getDate() - 1
      if (this.formInline.month) {
        // console.log(this.formInline.month)
        const searchmonth = this.formInline.month
        const arr = searchmonth.split('-')
        // console.log(arr)
        const searchDate = new Date(arr[0], arr[1], 0)
        const searchMonth = searchDate.getMonth() + 1
        // console.log('搜索月份',searchMonth)
        // console.log(searchDate)
        // console.log(date)
        if (searchMonth < curMonth) {
          day = searchDate.getDate()
        }
      }
      // console.log(day)
      for (let i = 0; i < day; i++) {
        this.cols.push({
          // keyName: '',
          label: i + 1 + '',
          width: '150px',
          slot: 'main',
        })
      }
    },
    getOptions() {
      let url = `${this.baseUrl}/getfleet`;
      const params = {
        userid: this.user.id,
      }
      this.post(url, params, ({ msg, team, month }) => {
        if (msg == 'success') {
          this.setFleet({ team })
          this.$set(this.formInline, 'month', month || this.CURR_MONTH)
          this.$forceUpdate()
          this.getList()
        } else {
          this.$message({
            type: 'error',
            message: '获取数据失败，请稍后再试！'
          });
        }
      }, err => {
        console.log(err)
        this.$message({
          type: 'error',
          message: '获取数据失败，请稍后重试！'
        });
      })
    },
    onDialogClose() {
      this.mform = { getid: '' }
      this.showmformCtrl1 = false
      this.mformCtrl[1].disabled = false
    },
    changeType(v) {
      // console.log(v)
      this.showmformCtrl1 = [3, 4].includes(v)
      // 岗位类型编号，清空getid重新选择
      // delete this.mform.getid
      // 岗位类型修改，清空表单
      const {
        carid,
        month,
        day,
        monthday,
        type,
      } = this.mform
      this.mform = {
        carid,
        month,
        day,
        monthday,
        type,
      }
      this.$forceUpdate()
      // console.log({...this.mform})
      if (this.showmformCtrl1) {
        // 打短司机/押运textSelect控件，特殊搜索
        this.getShortNames({ type: v, carid: this.mform.carid })
      } else {
        // 司机/押运select控件，正常搜索
        this.getNames({ type: v, carid: this.mform.carid })
      }
      // 打短司机/押运修改label名称
      if (v == 4) {
        this.mformCtrl1.map(c => {
          if (c.keyName == 'paymoney') {
            c.options[1].label = '押运支付'
          }
        })
      } else {
        this.mformCtrl1.map(c => {
          if (c.keyName == 'paymoney') {
            c.options[1].label = '司机支付'
          }
        })
      }
    },
    getShortNames(params = {}, cb) {
      let url = `${this.baseUrl}/findname`;
      // console.log(url, params)
      this.post(url, params, (res) => {
        // console.log(res);
        const { msg, data } = res
        if (msg === 'success') {
          // console.log(data)
          this.mformCtrl.map(v => {
            // console.log({...v})
            if (v.keyName === 'get_name' && v.type === 'textSelect') {
              v.options = data.map(c => {
                return {
                  label: c.id,
                  value: c.name,
                }
              })
              // console.log(v.options)
            }
            if (typeof cb === 'function') cb()
          })
        } else {
          this.$message({
            type: 'error',
            message: msg,
          });
        }
      }, err => {
        console.log(err)
        this.$message({
          type: 'error',
          message: '获取数据失败，请稍后重试！'
        });
      })
    },
    getNames(params = {}, cb) {
      let url = `${this.baseUrl}/findname`;
      // console.log(url, params)
      this.post(url, params, (res) => {
        // console.log(res);
        const { msg, data } = res
        if (msg === 'success') {
          // console.log(data)
          this.mformCtrl.map(v => {
            // console.log({...v})
            if (v.keyName === 'getid' && v.type === 'select') {
              v.options = data.map(c => {
                return {
                  label: c.name,
                  value: c.id + '',
                }
              })
              // console.log(v.options)
            }
            if (typeof cb === 'function') cb()
          })
        } else {
          this.$message({
            type: 'error',
            message: msg,
          });
        }
      }, err => {
        console.log(err)
        this.$message({
          type: 'error',
          message: '获取数据失败，请稍后重试！'
        });
      })
    },
    // changeName(v) {
    //   // console.log(v)
    //   this.mform.getid = v
    //   this.$forceUpdate()
    //   this.mformCtrl[2].options.map(o => {
    //     if (v == o.value) {
    //       this.mform.name = o.label
    //     }
    //   })
    // },
    showAddDetail(day, { carid }) {
      this.title = '添加详情'
      this.modalSubmitUrl = 'addkapqin'
      let month = this.formInline.month
      // console.log(day)
      let monthday = month
      day > 9 ? monthday += '-' + day : monthday += '-0' + day
      // console.log(month)
      this.mform = {
        month,
        monthday,
        day,
        type: 1,
        paymoney: 2,
        carid,
      }
      // 出处可编辑
      this.mformCtrl1[1].disabled = false
      // console.log({ ...this.mform })
      // 默认搜司机
      this.getNames({ type: 1, carid })
      this.showDialog()
    },
    showDetail(type, day, data, idx) {
      // type: 1.司机，2.押运，3.打短司机，4.打短押运
      // day: 日期
      // idx: 第idx个打短司机/押运
      // console.log(type, day, { ...data }, idx)
      this.title = '修改详情'
      if ((type === 1 && data[`dname${day}`] === '无') ||
        (type === 2 && data[`ename${day}`] === '无')) {
        // 司机或押运显示无时，不能直接打开弹窗修改，需要点击‘+’号添加
        return
      }
      this.modalSubmitUrl = 'updatekapqin'
      let month = this.formInline.month
      // console.log(day)
      let monthday = month
      day > 9 ? monthday += '-' + day : monthday += '-0' + day
      // console.log(month)
      const { carid } = data
      // 获取姓名
      let name = data[`dname${day}`]
      // 押运姓名
      if (type === 2) {
        name = data[`ename${day}`]
      }
      this.mform = {
        month,
        monthday,
        day,
        type,
        name,
        carid,
        getid: null,
      }
      // 打短司机
      if (type === 3) {
        const { id, driver, money } = data[`driverwork${day}`][idx]
        this.mform = {
          ...this.mform,
          name: driver,
          money,
          id,
        }
        this.showmformCtrl1 = true
        // 打短司机/押运修改label名称
        this.mformCtrl1.map(c => {
          if (c.keyName == 'paymoney') {
            c.options[1].label = '司机支付'
          }
        })
        // 获取打短司机数据
        this.getmylist({ type, carid, month, day, id })
      }
      // 打短押运
      if (type === 4) {
        const { id, driver, money } = data[`escortwork${day}`][idx]
        this.mform = {
          ...this.mform,
          name: driver,
          money,
          id,
        }
        this.showmformCtrl1 = true
        // 打短司机/押运修改label名称
        this.mformCtrl1.map(c => {
          if (c.keyName == 'paymoney') {
            c.options[1].label = '押运支付'
          }
        })
        // 获取打短押运数据
        this.getmylist({ type, carid, month, day, id })
      }
      // 编辑时岗位不可修改
      this.mformCtrl[1].disabled = true
      // console.log({ ...this.mform })
      // 获取在职司机/押运名单列表
      this.getNames({ type, carid }, () => {
        const options = this.mformCtrl[2].options
        if (options.length) {
          // console.log(options)
          options.map(o => {
            if (name == o.label) {
              // console.log(driver)
              this.mform.getid = o.value;
            }
          })
          // console.log({...this.mform})
        }
      })
      this.showDialog()
    },
    // 获取打短司机/押运数据
    getmylist(params) {
      let url = `${this.baseUrl}/getmylist`;
      // console.log(url, params)
      this.post(url, params, (res) => {
        // console.log(res);
        const { msg, data } = res
        if (msg === 'success' && data) {
          // console.log(data)
          const {
            name,
            paymoney,
            remark,
          } = data
          this.mform = {
            ...this.mform,
            get_name: name,
            paymoney: Number(paymoney),
            remark,
          }
          // console.log({ ...this.mform })
          // 工资出处不可编辑
          this.mformCtrl1[1].disabled = true
          // console.log(this.mformCtrl1[1].options)
          this.$forceUpdate()
        } else {
          this.$message({
            type: 'error',
            message: msg,
          });
        }
      }, err => {
        console.log(err)
        this.$message({
          type: 'error',
          message: '获取数据失败，请稍后重试！'
        });
      })
    },
    modalSubmitConfirm() {
      console.log({ ...this.mform });
      this.$refs['mofalForm'].validate((valid) => {
        // console.log(valid)
        if (valid) {
          this.$confirm('确认提交吗？', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(this.onModalSubmit).catch(() => { });
        } else {
          console.log('验证不通过');
          console.log({ ...this.mform })
          this.$message({
            type: 'error',
            message: '请修改错误信息',
          });
          return false;
        }
      });
    },
    delItem() {
      this.$confirm('确认删除吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.delReq();
      }).catch(() => { });
    },
    delReq() {
      this.loading = true
      let url = `${this.baseUrl}/delkapqin`;
      const params = {
        userid: this.user.id,
        ...this.mform,
      }
      this.post(url, params, ({ msg }) => {
        this.loading = false
        if (msg == 'success') {
          this.$message({
            type: 'success',
            message: '删除成功!',
          });
          this.getList()
          this.hideDialog()
        } else {
          this.$message({
            type: 'error',
            message: '删除失败，请稍后再试！'
          });
        }
      }, err => {
        console.log(err)
        this.$message({
          type: 'error',
          message: '删除失败，请稍后重试！'
        });
      })
    },
  },
  created() {
    const { user_group_id, id } = this.user
    if (user_group_id == 5) {
      this.formInline.fleet = id
      this.formCtrl.splice(1, 1)
      this.baseParams.push('fleet')
    }
    this.MONTH = this.CURR_MONTH
    this.$set(this.formInline, 'month', this.CURR_MONTH)
  },
  mounted() {
    // this.getDayCount();
    this.getList();
    this.getOptions();
  },
};
</script>

<style lang="less" scoped>
/deep/ .fillet .el-form--inline .el-form-item:first-child {
  margin-right: 20px;
}

/deep/ .fillet .el-form--inline .el-form-item:first-child {
  margin-right: 0px;
  padding-right: 80px;
  position: relative;

  &::after {
    position: absolute;
    content: "";
    right: 40px;
    top: 6px;
    width: 1px;
    height: 28px;
    overflow: hidden;
    background-color: #EBEDF0;
  }
}

.nameBtn {
  cursor: pointer;

  &:hover {
    color: #2691FF;
  }
}

.iconBtn {
  color: #ccc;
  font-size: 20px;
  position: absolute;
  top: 5px;
  right: 5px;
  cursor: pointer;
}

.dialog {
  /deep/ .el-dialog {
    width: 456px;

    .el-form {

      .el-input,
      .el-textarea {
        width: 230px;
      }
    }
  }

  .btns {
    text-align: center;
  }
}
</style>
